import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { Warehouse } from '../models/warehouse.model';

@Injectable({
  providedIn: 'root'
})
export class WarehouseValidatorService extends ValidatorService {
  isValid(data: Warehouse) {
    this.errors = [];

    if (!this.isSupplied(data.name)) {
      this.errors.push('name');
    }

    return this.errors.length === 0;
  }
}
